import React, { FC, useState, useEffect } from 'react';
import { SuitesCardProps } from './SuitesCard.types';
import { StyledSuitesCard } from './SuitesCard.styles';
import { Button, Eyebrow, EyebrowEnum } from '@marriott/mi-ui-library';
import { MLogoContainer } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';
import { Image } from '@marriott/mi-ui-library';
import { getDirection } from '../../modules/helpers';

export const SuitesCard: FC<SuitesCardProps> = ({
  eyebrow,
  ctaLink,
  title,
  trackingProperties,
  dynamicMedia,
  openInNewTab = false,
  styleclass,
  logo,
  custom_click_track_value,
  isLogoFlagEnabled = false,
}) => {
  const [direction, setDirection] = useState(false);
  useEffect(() => {
    setDirection(getDirection());
  }, []);

  return (
    <StyledSuitesCard
      data-testid="luxury-SuitesCard"
      data-component-name="m-luxury-SuitesCard"
      className={clsx(styleclass, 'color-scheme2')}
    >
      <Button
        isLink
        testId="SuitesCardBtn"
        href={ctaLink}
        target={openInNewTab ? '_blank' : '_self'}
        aria-label={eyebrow ? eyebrow + ' ' + title : title}
        trackingProperties={trackingProperties}
        rel={`${openInNewTab ? 'noopener noreferrer' : ''}`}
        className={clsx(
          `${`card-chevron icon-arrow${direction ? '-left' : '-right'}${openInNewTab ? '-external' : ''}`}`
        )}
        custom_click_track_value={custom_click_track_value}
      >
        <div className="suites-card-container">
          <Image
            altText={dynamicMedia?.altText}
            renditions={dynamicMedia?.renditions}
            dynamic={dynamicMedia?.dynamic}
            defaultImageURL={dynamicMedia?.assetPath}
            customClass="suites-image"
            loading="eager"
          />
          <div className="suites-card-content">
            <div className="card-text-wrapper">
              <div className="card-texts p-3 mt-2">
                <div>
                  {logo && isLogoFlagEnabled && (
                    <MLogoContainer
                      brand={logo}
                      color={'background-aware'}
                      aspectRatio={'3:2'}
                      width={90}
                      height={60}
                      alignment={'Center Left'}
                      isLink={false}
                      ariaRole="img"
                      brandFullName={title}
                    />
                  )}
                </div>
                <div className="d-flex mr-2">
                  {eyebrow && <Eyebrow text={eyebrow} variation={EyebrowEnum.Overlay} />}
                  <span className={clsx('col-3')}></span>
                </div>
                <div className="d-flex mt-2">
                  <h4 className="card-text">{title}</h4>
                  <span className={clsx('col-3')}></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Button>
    </StyledSuitesCard>
  );
};
